document.addEventListener('DOMContentLoaded', function () {
  const popup = document.getElementById('location-popup');
  if (!popup) return;

// to remove old logic
const VERSION = "v11";
const current = localStorage.getItem("store_version");

if (current !== VERSION) {
  localStorage.removeItem('store_name');
  localStorage.removeItem('store_session_time');
  localStorage.removeItem('store_name_time');
  localStorage.removeItem('tabs');
  localStorage.setItem('store_version', VERSION);
}

let store = localStorage.getItem('store_name');

const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
const isArabic = document.documentElement.lang.includes('ar');

const tabId =
    sessionStorage.getItem('tab_id') ||
    (crypto.randomUUID ? crypto.randomUUID() : 'tab-' + Math.random().toString(36).slice(2));

  sessionStorage.setItem('tab_id', tabId);


if (!isMobile) {

  window.addEventListener('beforeunload', () => {
    localStorage.setItem(`closing_${tabId}`, Date.now());
  });

  let tabs = JSON.parse(localStorage.getItem('tabs') || '[]');

  tabs = tabs.filter(id => typeof id === 'string' && id.length > 0);

  tabs = tabs.filter(id => {
    const closingTime = localStorage.getItem(`closing_${id}`);

    if (!closingTime) return true;

const diff = Date.now() - Number(closingTime);

if (diff < 9000) {
  localStorage.removeItem(`closing_${id}`);
  return true;
}

if (diff < 10 * 60 * 1000) {
  localStorage.removeItem(`closing_${id}`);
  return false;
}

localStorage.removeItem(`closing_${id}`);
return false;
  });

  if (tabs.length === 0) {
    localStorage.removeItem('store_name');
    localStorage.removeItem('store_session_time');
  }

  if (!tabs.includes(tabId)) {
    tabs.push(tabId);
  }

  localStorage.setItem('tabs', JSON.stringify(tabs));
}

if (isMobile) {
    const time = Number(localStorage.getItem('store_session_time'));
    const MOBILE_TIMEOUT = 12 * 60 * 60 * 1000;
    // const MOBILE_TIMEOUT = 60 * 1000;

    if (store && time && (Date.now() - time > MOBILE_TIMEOUT)) {
      localStorage.removeItem('store_name');
      localStorage.removeItem('store_session_time');
      store = null;
    }
  }

  initPopupListeners(isArabic);

  if (store) {
    updateLocationBar(store, isArabic);
    return;
  }else {
showLocationPopup(isArabic);
  }

});

function showLocationPopup(isArabic) {
  const popup = document.getElementById('location-popup');
  document.documentElement.classList.add('location-popup-active');
  document.body.classList.add('location-popup-active');
  popup.classList.remove('hidden');
}

function hideLocationPopup() {
  const popup = document.getElementById('location-popup');
  document.documentElement.classList.remove('location-popup-active');
  document.body.classList.remove('location-popup-active');
  popup.classList.add('hidden');
}

function updateLocationBar(storeName, isArabic) {
  const utilityBar = document.querySelector('.utility-bar');
  const showLocation = utilityBar ? utilityBar.dataset.showLocation === 'true' : true;

  if (!showLocation) return;

  const announcementSpans = document.querySelectorAll('.js-announcement-text');
  const label = isArabic ? `توصيل الطلب من` : `Order delivered from`;

  announcementSpans.forEach(span => {
    span.classList.add('has-location');
    span.innerHTML = `${label}: <span class="loc-name">${storeName}</span>`;

    span.onclick = (e) => {
      e.preventDefault();
      showLocationPopup(isArabic);
    };

    const parentLink = span.closest('a');
    if (parentLink) {
      parentLink.onclick = (e) => {
        e.preventDefault();
        showLocationPopup(isArabic);
      };
    }
  });
}

let listenersInitialized = false;
function initPopupListeners(isArabic) {
  if (listenersInitialized) return;

  const dropdown = document.getElementById('location-dropdown');
  const selected = document.getElementById('dropdown-selected');
  const items = document.querySelectorAll('.dropdown__item');
  const info = document.getElementById('location-info');
  const helperText = document.getElementById('location-helper');
  const confirmBtn = document.getElementById('location-confirm');


  selected.addEventListener('click', () => {
    dropdown.classList.toggle('open');
  });

  let selectedStore = null;
  let selectedLocationId = null;

  items.forEach(item => {
    item.addEventListener('click', () => {
      selectedStore = item.dataset.store;
      selectedLocationId = item.dataset.locationId || (window.getLocationIdForBranch ? window.getLocationIdForBranch(selectedStore) : '');
      selected.innerText = item.innerText.trim();
      dropdown.classList.remove('open');
      helperText.innerText = "";
      info.innerHTML = isArabic
        ? `طلبك سيصل اليك من: <span class="loc-name-popup">${selectedStore}</span>`
        : `Your order will be delivered from: <span class="loc-name-popup">${selectedStore}</span>`;
    });
  });

  document.addEventListener('click', (e) => {
    if (dropdown && !dropdown.contains(e.target)) {
      dropdown.classList.remove('open');
    }
  });

  confirmBtn.addEventListener('click', function () {
    if (!selectedStore) {
      alert(isArabic ? 'يرجى اختيار صيدلية' : 'Please select pharmacy');
      return;
    }

    const mappedConfigId = window.getLocationIdForBranch ? window.getLocationIdForBranch(selectedStore) : '';
    const locId = (selectedLocationId && selectedLocationId !== selectedStore) ? selectedLocationId : (mappedConfigId || selectedStore);

    if (window.BranchInventory && window.BranchInventory.setSelectedBranch) {
      window.BranchInventory.setSelectedBranch({
        id: selectedStore,
        name: selectedStore,
        locationId: locId
      });
    } else {
      localStorage.setItem('store_name', selectedStore);
      localStorage.setItem('store_session_time', Date.now());

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            store_name: selectedStore,
            branch_id: selectedStore,
            shopify_location_id: locId
          }
        })
      });
    }

    updateLocationBar(selectedStore, isArabic);
    hideLocationPopup();
  });

  autoSelectNearestStore(items, selected, info, helperText, isArabic, (store, itemEl) => {
    selectedStore = store;
    if (itemEl) {
      selectedLocationId = itemEl.dataset.locationId || (window.getLocationIdForBranch ? window.getLocationIdForBranch(store) : '');
    }
  });

  const langButton = document.querySelector('#PopupLangButton');
  if (langButton) {
    langButton.addEventListener('click', () => {
      const form = langButton.closest('form');
      const input = form.querySelector('input[name="locale_code"]');
      if (form && input) {
        input.value = langButton.dataset.value;
        form.submit();
      }
    });
  }

  listenersInitialized = true;
}

function autoSelectNearestStore(items, selected, info, helperText, isArabic, setStore) {
  if (!navigator.geolocation) {
    helperText.innerText = isArabic
      ? "* اختر الصيدلية الأقرب لك"
      : "* Choose your nearest pharmacy";
    return;
  }

  helperText.innerText = isArabic
    ? "* جاري تحديد أقرب صيدلية..."
    : "* Detecting nearest pharmacy...";

  navigator.geolocation.getCurrentPosition(
    (position) => {
      const userLat = position.coords.latitude;
      const userLng = position.coords.longitude;

      let nearestItem = null;
      let shortestDistance = Infinity;

      items.forEach(item => {
        const lat = parseFloat(item.dataset.lat);
        const lng = parseFloat(item.dataset.lng);
        if (!lat || !lng) return;

        const distance = getDistance(userLat, userLng, lat, lng);
        if (distance < shortestDistance) {
          shortestDistance = distance;
          nearestItem = item;
        }
      });

      if (nearestItem) {
        const storeName = nearestItem.dataset.store;
        selected.innerText = nearestItem.innerText.trim();
        setStore(storeName, nearestItem);
        
        info.innerHTML = isArabic
          ? `طلبك سيصل اليك من: <span class="loc-name-popup">${storeName}</span>`
          : `Your order will be delivered from: <span class="loc-name-popup">${storeName}</span>`;

        helperText.innerText = isArabic
          ? "* أقرب صيدلية لموقعك"
          : "* Nearest pharmacy to your location";
      }
    },
    () => {
      helperText.innerText = isArabic
        ? "* اختر الصيدلية الأقرب لك"
        : "* Choose your nearest pharmacy";
    },
    { enableHighAccuracy: false }
  );
}

function getDistance(lat1, lon1, lat2, lon2) {
  const R = 6371;
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * Math.PI / 180) *
    Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLon / 2) *
    Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}